import React from "react";

import LpgContinueOutline from "@/icons/Lpg/ContinueOutline";

import { Icon } from "../Icon";

import styles from "./Breadcrumbs.scss";

const ContinueIcon = () => (
  <span className={styles.icon}>
    <Icon icon={LpgContinueOutline} size={Icon.Size.xxsmall} />
  </span>
);

export default ContinueIcon;
